import type { VelocityProviderProps } from '@velocity/ui'

export type VelocityTranslateFn = NonNullable<
  VelocityProviderProps['translateFn']
>

/**
 * Velocity draws some of its own labels, the "optional" marker beside a field
 * label among them, from bundles it ships itself; it ships none for several of
 * the languages this app offers. A locale it does not know falls through to
 * its English resource with no warning, so the keys below are pointed at the
 * content paths that already carry the wording.
 */
export const VELOCITY_CONTENT_KEYS: Record<string, string> = {
  vel_form_field_label_optional: 'fields.shared.optional',
}

/**
 * Velocity asks for a translation only when its own bundle for the active
 * locale has no entry for the key; for a locale it ships no bundle for, that
 * is every key. Answering from the app's content keeps those locales from
 * silently showing English.
 */
export const createVelocityTranslateFn =
  (c: (path: string) => string): VelocityTranslateFn =>
  (key) => {
    const path = VELOCITY_CONTENT_KEYS[key]

    if (!path) return undefined

    const text = c(path)

    // A content lookup echoes the path back when nothing matches; letting that
    // through would print 'fields.shared.optional' on screen.
    return text === path ? undefined : text
  }
